import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Auto-reload guard: if the user's tab has been open for a while and the
// hashed JS bundle URL has changed on the server (= a new deploy happened),
// silently reload once to pick up the latest version. Prevents stale-cache
// "the app is broken" reports during/after investor demos.
if (typeof window !== "undefined") {
  let _reloaded = false;
  const checkForNewBuild = async () => {
    if (_reloaded) return;
    try {
      const res = await fetch(window.location.origin + "/?_cb=" + Date.now(), {
        cache: "no-store",
        credentials: "omit",
      });
      const html = await res.text();
      const m = html.match(/static\/js\/main\.[a-z0-9]+\.js/);
      const liveBundle = m ? m[0] : null;
      const currentBundle = Array.from(document.scripts)
        .map((s) => (s.src.match(/static\/js\/main\.[a-z0-9]+\.js/) || [])[0])
        .find(Boolean);
      if (liveBundle && currentBundle && liveBundle !== currentBundle) {
        _reloaded = true;
        window.location.reload();
      }
    } catch {
      // network blip — ignore, try again next tick
    }
  };
  // Check when the tab becomes visible again (user came back to the tab)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkForNewBuild();
  });
  // Also poll every 10 minutes for long-open sessions
  setInterval(checkForNewBuild, 10 * 60 * 1000);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
